/**
 * Web-only storage utility — pure localStorage
 */

export async function setStorage(key: string, value: string): Promise<boolean> {
    try {
        localStorage.setItem(key, value);
        return true;
    } catch (error) {
        console.log(`存储数据失败 [${key}]:`, error);
        return false;
    }
}

export async function getStorage(key: string): Promise<string | null> {
    try {
        return localStorage.getItem(key);
    } catch (error) {
        console.log(`读取数据失败 [${key}]:`, error);
        return null;
    }
}

export async function removeStorage(key: string): Promise<boolean> {
    try {
        localStorage.removeItem(key);
        return true;
    } catch (error) {
        console.log(`删除数据失败 [${key}]:`, error);
        return false;
    }
}

export async function hasStorage(key: string): Promise<boolean> {
    const value = await getStorage(key);
    return !!value;
}

export async function clearStorage(): Promise<boolean> {
    try {
        localStorage.clear();
        return true;
    } catch (error) {
        console.log('清空存储失败:', error);
        return false;
    }
}

export async function getAllKeys(): Promise<string[]> {
    try {
        return Object.keys(localStorage);
    } catch (error) {
        console.log('获取所有键名失败:', error);
        return [];
    }
}

export async function setMultipleStorage(items: Record<string, string>): Promise<boolean> {
    try {
        Object.entries(items).forEach(([key, value]) => {
            localStorage.setItem(key, value);
        });
        return true;
    } catch (error) {
        console.log('批量存储数据失败:', error);
        return false;
    }
}

export async function getMultipleStorage(keys: string[]): Promise<Record<string, string | null>> {
    try {
        const result: Record<string, string | null> = {};
        keys.forEach(key => {
            result[key] = localStorage.getItem(key);
        });
        return result;
    } catch (error) {
        console.log('批量读取数据失败:', error);
        return {};
    }
}
